import { FTProcess } from '@/models/FTProcess';
import { initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index';
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            family: ['Board']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },{
              name: 'Length',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.length', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Type',
          type: 'dropdown',
          value: 'embossingType',
          optionsArray: [ 'Simple', 'Continuous'],
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  const boardInputFtProcessRow = process.inputs[0];
  const outputFTProcessRow = process.outputs[0];
  outputFTProcessRow.goodsObject.copyFrom(boardInputFtProcessRow.goodsObject);
  outputFTProcessRow.quantity = boardInputFtProcessRow.quantity;
  conversionResult.outputs[0] = outputFTProcessRow;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputFTProcessRow.quantity;
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;
  if (process.machineDetail.pcsPerStroke) {
      conversionResult.details.kgPerHour = 60 * outputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      conversionResult.details.plannedHours = outputFTProcessRow.quantity / conversionResult.details.kgPerHour;
  }

  return conversionResult;
}